var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"vx-row"}),_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full md:w-1/2"},[_c('chartjs-bar-chart')],1),_c('div',{staticClass:"vx-col w-full md:w-1/2"},[_c('chartjs-bar-chart')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }